namespace RioERP.Users {
    export interface BrandAmbassadorForm {
        Name: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        Email: Serenity.EmailEditor;
        AlternateEmail: Serenity.EmailEditor;
        Mobile: Serenity.StringEditor;
        AlternateMobile: Serenity.StringEditor;
        Address: Serenity.StringEditor;
        City: Serenity.StringEditor;
        StateId: Serenity.IntegerEditor;
        Gstin: Serenity.StringEditor;
        Pan: Serenity.StringEditor;
        GstCertificate: Serenity.StringEditor;
        BankName: Serenity.StringEditor;
        BankAccountType: Serenity.IntegerEditor;
        BankAccountName: Serenity.StringEditor;
        BankAccountNo: Serenity.StringEditor;
        BankIfscCode: Serenity.StringEditor;
        Pincode: Serenity.IntegerEditor;
        DiscountCoupon: Serenity.StringEditor;
        CustomerId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
    }

    export class BrandAmbassadorForm extends Serenity.PrefixedContext {
        static formKey = 'Users.BrandAmbassador';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BrandAmbassadorForm.init)  {
                BrandAmbassadorForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.EmailEditor;
                var w3 = s.IntegerEditor;

                Q.initFormType(BrandAmbassadorForm, [
                    'Name', w0,
                    'Description', w1,
                    'Email', w2,
                    'AlternateEmail', w2,
                    'Mobile', w0,
                    'AlternateMobile', w0,
                    'Address', w0,
                    'City', w0,
                    'StateId', w3,
                    'Gstin', w0,
                    'Pan', w0,
                    'GstCertificate', w0,
                    'BankName', w0,
                    'BankAccountType', w3,
                    'BankAccountName', w0,
                    'BankAccountNo', w0,
                    'BankIfscCode', w0,
                    'Pincode', w3,
                    'DiscountCoupon', w0,
                    'CustomerId', w3,
                    'UserId', w3
                ]);
            }
        }
    }
}
